var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.69-472.31h272.62v-176.61H535.69v176.61ZM672-508.69l-106.46-70.46v-38.39L672-547.08l106.46-70.46v38.39L672-508.69ZM40-199.38v-561.24h880v561.24H40Zm295.91-175.39q41.63 0 70.86-29.14Q436-433.05 436-474.68q0-41.63-29.14-70.86-29.14-29.23-70.77-29.23-41.63 0-70.86 29.14Q236-516.49 236-474.86q0 41.63 29.14 70.86 29.14 29.23 70.77 29.23ZM116.62-231.38h431.76q-51-33.24-102.65-56.62-51.65-23.38-110.23-23.38-58.58 0-112.73 22.88-54.15 22.88-106.15 57.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contact_mail.258e97ebb1d0af59b7569ae8f46dfeb4.svg";
export { ForwardRef as ReactComponent };